import { Wizard } from '@/components/wizard/Wizard';

import {
  upsertGroupMappingFlow,
  type UpsertGroupMappingState,
} from './upsertGroupMappingFlow';

interface UpsertGroupMappingPanelProps {
  editMode: boolean;
  idpId: string;
  providerGroupId: string;
  roleIds: string[];
  groupId?: string;
  onSave: (state: UpsertGroupMappingState) => Promise<void>;
  onAbort: () => void;
}

export function UpsertGroupMappingPanel(props: UpsertGroupMappingPanelProps) {
  const save = async (state: UpsertGroupMappingState) => {
    await props.onSave(state);
    return true;
  };

  return (
    <Wizard<UpsertGroupMappingState>
      onAbort={props.onAbort}
      onFinish={save}
      hideBackArrow={true}
      flow={[upsertGroupMappingFlow]}
      initialState={{
        editMode: props.editMode,
        idpId: props.idpId,
        providerGroupId: props.providerGroupId,
        roleIds: props.roleIds,
        groupId: props.groupId,
      }}
      title={props.editMode ? 'Edit Permissions' : 'New Group Mapping'}
    />
  );
}
